import {
  AllOtherPerilsDeductible,
  CoverageAnimalLiabilityValue,
  CoverageDamageToPropertyOfOthersValue,
  CoverageDebrisRemovalValue,
  CoverageELiabilityValue,
  CoverageEquipmentBreakdownValue,
  CoverageFMedicalPaymentToOthersValue,
  CoverageFungiWetOrDryRotOrBacteriaPropertyValue,
  CoverageIdentityFraudExpenseValue,
  CoverageLossAssessmentValue,
  CoverageWaterBackupAndSumpOverflowValue,
  ResidenceBurglaryValue,
  WaterDamageDeductible,
  WindHailDeductible,
} from "@covertree/new-business-graphql";
import { CoverageAccessor, ExtraCoverageAccessor } from "../..";
import { ExtensionCoverageAccessor } from "../coverageMappings/types";

export function mapNumberToDollarsEnum(
  value: number | string,
  accessor: CoverageAccessor
):
  | AllOtherPerilsDeductible
  | CoverageAnimalLiabilityValue
  | CoverageDamageToPropertyOfOthersValue
  | CoverageDebrisRemovalValue
  | CoverageELiabilityValue
  | CoverageEquipmentBreakdownValue
  | CoverageIdentityFraudExpenseValue
  | CoverageFMedicalPaymentToOthersValue
  | CoverageFungiWetOrDryRotOrBacteriaPropertyValue
  | CoverageIdentityFraudExpenseValue
  | CoverageLossAssessmentValue
  | CoverageWaterBackupAndSumpOverflowValue
  | ResidenceBurglaryValue
  | WaterDamageDeductible
  | WindHailDeductible {
  if (accessor === "deductibles.allOtherPerilsDeductible") {
    switch (value) {
      case 500:
        return AllOtherPerilsDeductible.Dollars500;
      case 1000:
        return AllOtherPerilsDeductible.Dollars1K;
      case 2500:
        return AllOtherPerilsDeductible.Dollars2K500;
      case 5000:
        return AllOtherPerilsDeductible.Dollars5K;
      case 10000:
        return AllOtherPerilsDeductible.Dollars10K;
      default:
        throw new Error("Unknown value for AllOtherPerilsDeductible");
    }
  }

  if (accessor === "deductibles.waterDamageDeductible") {
    switch (value) {
      case 2500:
        return WaterDamageDeductible.Dollars2K500;
      case 5000:
        return WaterDamageDeductible.Dollars5K;
      case 10000:
        return WaterDamageDeductible.Dollars10K;
      default:
        throw new Error("Unknown value for WaterDamageDeductible");
    }
  }

  if (accessor === "deductibles.windHailDeductible") {
    switch (value) {
      case 500:
        return WindHailDeductible.Dollars500;
      case 1000:
        return WindHailDeductible.Dollars1K;
      case 2500:
        return WindHailDeductible.Dollars2K500;
      case 5000:
        return WindHailDeductible.Dollars5K;
      case 10000:
        return WindHailDeductible.Dollars10K;
      default:
        throw new Error("Unknown value for WindHailDeductible");
    }
  }

  if (accessor === "animalLiability.value") {
    switch (value) {
      case 10000:
        return CoverageAnimalLiabilityValue.Dollars10K;
      case 25000:
        return CoverageAnimalLiabilityValue.Dollars25K;
      case 50000:
        return CoverageAnimalLiabilityValue.Dollars50K;
      case 100000:
        return CoverageAnimalLiabilityValue.Dollars100K;
      case 300000:
        return CoverageAnimalLiabilityValue.Dollars300K;
      case 500000:
        return CoverageAnimalLiabilityValue.Dollars500K;
      case "Excluded":
      case 0:
        return CoverageAnimalLiabilityValue.Excluded;
      default:
        throw new Error("Unknown value for CoverageAnimalLiabilityValue");
    }
  }

  if (accessor === "damageToPropertyOfOthers.value") {
    switch (value) {
      case 500:
        return CoverageDamageToPropertyOfOthersValue.Dollars500;
      default:
        throw new Error(
          "Unknown value for CoverageDamageToPropertyOfOthersValue"
        );
    }
  }

  if (accessor === "coverageFMedicalPaymentToOthers.value") {
    switch (value) {
      case 500:
        return CoverageFMedicalPaymentToOthersValue.Dollars500;
      case 1000:
        return CoverageFMedicalPaymentToOthersValue.Dollars1K;
      case 2000:
        return CoverageFMedicalPaymentToOthersValue.Dollars2K;
      case 3000:
        return CoverageFMedicalPaymentToOthersValue.Dollars3K;
      case 4000:
        return CoverageFMedicalPaymentToOthersValue.Dollars4K;
      case 5000:
        return CoverageFMedicalPaymentToOthersValue.Dollars5K;
      default:
        throw new Error(
          "Unknown value for CoverageFMedicalPaymentToOthersValue"
        );
    }
  }

  if (accessor === "lossAssessment.value") {
    switch (value) {
      case 1000:
        return CoverageLossAssessmentValue.Dollars1K;
      case 5000:
        return CoverageLossAssessmentValue.Dollars5K;
      default:
        throw new Error("Unknown value for CoverageLossAssessmentValue");
    }
  }

  if (accessor === "waterBackupAndSumpOverflow.value") {
    switch (value) {
      case 5000:
        return CoverageWaterBackupAndSumpOverflowValue.Dollars5K;
      case 10000:
        return CoverageWaterBackupAndSumpOverflowValue.Dollars10K;
      case 25000:
        return CoverageWaterBackupAndSumpOverflowValue.Dollars25K;
      default:
        throw new Error(
          "Unknown value for CoverageWaterBackupAndSumpOverflowValue"
        );
    }
  }

  if (accessor === "residenceBurglary.value") {
    switch (value) {
      case 5000:
        return ResidenceBurglaryValue.Dollars5K;
      case 10000:
        return ResidenceBurglaryValue.Dollars10K;
      case 15000:
        return ResidenceBurglaryValue.Dollars15K;
      case 20000:
        return ResidenceBurglaryValue.Dollars20K;
      case 30000:
        return ResidenceBurglaryValue.Dollars30K;
      case 40000:
        return ResidenceBurglaryValue.Dollars40K;
      case 50000:
        return ResidenceBurglaryValue.Dollars50K;
      default:
        throw new Error("Unknown value for ResidenceBurglaryValue");
    }
  }

  if (accessor === "debrisRemoval.value") {
    switch (value) {
      case 5000:
        return CoverageDebrisRemovalValue.Dollars5K;
      case 10000:
        return CoverageDebrisRemovalValue.Dollars10K;
      default:
        throw new Error("Unknown value for CoverageDebrisRemovalValue");
    }
  }

  if (
    accessor === "coverageEPersonalLiability.value" ||
    accessor === "coverageEPremisesLiability.value"
  ) {
    switch (value) {
      case 100000:
        return CoverageELiabilityValue.Dollars100K;
      case 300000:
        return CoverageELiabilityValue.Dollars300K;
      case 500000:
        return CoverageELiabilityValue.Dollars500K;
      case 25000:
        return CoverageELiabilityValue.Dollars25K;
      case 50000:
        return CoverageELiabilityValue.Dollars50K;
      default:
        throw new Error("Unknown value for CoverageELiabilityValue");
    }
  }

  if (accessor === ExtraCoverageAccessor.EquipmentBreakdown) {
    switch (value) {
      case 100000:
        return CoverageEquipmentBreakdownValue.Dollars100K;
      default:
        throw new Error("Unknown value for CoverageEquipmentBreakdownValue");
    }
  }

  if (accessor === ExtraCoverageAccessor.IdentityFraudExpense) {
    switch (value) {
      case 15000:
        return CoverageIdentityFraudExpenseValue.Dollars15K;
      default:
        throw new Error("Unknown value for CoverageIdentityFraudExpenseValue");
    }
  }

  if (
    accessor === ExtensionCoverageAccessor.FungiWetOrDryRotOrBacteriaProperty
  ) {
    switch (value) {
      case 3500:
        return CoverageFungiWetOrDryRotOrBacteriaPropertyValue.Dollars3K500;
      default:
        throw new Error(
          "Unknown value for CoverageFungiWetOrDryRotOrBacteriaPropertyValue"
        );
    }
  }

  throw new Error(`Unknown accessor: ${accessor}`);
}
